export default __webpack_public_path__ + "static/media/check.6ce21a59.svg";